<template>
  <div class="shadow" :class="type === 'dark' ? 'bg-default': ''">
    <div class="card-header border-0" :class="type === 'dark' ? 'bg-transparent': ''">
      <div class="row align-items-center">
        <div id="errorNotification" class="col-md-12">
          <base-alert v-if="errorMessage != null" type="danger">
            <span class="alert-inner--text"> {{errorMessage}}</span>
            <button type="button" class="close" aria-label="Close" @click="removeMessage('error')">
              <span aria-hidden="true">&times;</span>
            </button>
          </base-alert>
          <base-alert v-if="successMessage != null" type="success">
            <span class="alert-inner--text"> {{successMessage}}</span>
            <button type="button" class="close" aria-label="Close" @click="removeMessage('success')">
              <span aria-hidden="true">&times;</span>
            </button>
          </base-alert>
        </div>
        <div class="col-md-3">
          <h3 class="mb-0" :class="type === 'dark' ? 'text-white': ''">
            Notifications
          </h3>
        </div>
        <div class="col-md-9 text-right">
          <base-dropdown class="nav-link pr-0 float-right" position="right">
            <div class="media align-items-center" slot="title">
              <i class="fa fa-ellipsis-v float-right ml-2 btn-sm"></i>
            </div>
            <template>
              <div class=" dropdown-header noti-title">
                <h6 class="text-overflow m-0">ACTIONS</h6>
              </div>
              <div v-if="accessRights.includes('E')" class="dropdown-item"
                @click.prevent="showActionDrawer('export_list')">
                <i class="fa fa-download"></i>
                <span>Export</span>
              </div>
            </template>
          </base-dropdown>
        </div>
      </div>
    </div>

    <a-drawer title="" :width="480" placement="right" @close="onClose" :visible="drawerVisible">
      <div v-if="profileAction == 'export_list'">
        <h6 class="heading-small text-muted mb-4">Export Options</h6>
        <div>
          <base-radio name="0" class="mb-3" v-model="filterStatus" value="O">
            Export All
          </base-radio>
          <base-radio name="1" class="mb-3" v-model="filterStatus" value="1">
            Export Current Page
          </base-radio>
          <base-radio name="3" class="mb-3" v-model="filterStatus" value="3">
            Export Filtered
          </base-radio>
        </div>
        <div style="
          position: absolute;
          bottom: 0px;
          right: 0px;
          width: -webkit-fill-available;
          background-color: #f2f2f2;
          padding: 10px;
        ">
          <button type="button" class="btn btn-primary float-right" @click.prevent="download">
            Export
          </button>
        </div>
      </div>
    </a-drawer>

    <div class="table-responsive">
        <vuetable ref="vuetable" :api-url="apiURL" :http-options="httpOptions" :fields="fields" :sort-order="sortOrder"
          :show-sort-icons="true" :per-page="10" :css="css.table" pagination-path="" data-path="data"
          no-data-template="Empty" 
          @vuetable:load-error="onLoadError" @vuetable:pagination-data="onPaginationData">
        </vuetable>
    </div>

    <div class="card-footer d-flex justify-content-end" :class="type === 'dark' ? 'bg-transparent': ''">
      <div class="pagination ui basic segment grid">
        <vuetable-pagination ref="pagination" @vuetable-pagination:change-page="onChangePage" :css="css.pagination">
        </vuetable-pagination>
      </div>
    </div>

  </div>
</template>

<script>

 import axios from "axios";
 import { mapState, mapActions } from 'vuex'

  import Vuetable from "vuetable-2/src/components/Vuetable";
  import VuetablePagination from "vuetable-2/src/components/VuetablePagination";
  import secureStorage from '../../controllers/secureStorage';
  import HTTPRequest from '../../controllers/httpRequest.js';
  import moment from "moment";

  var component_x;

  export default {
    name: 'notifications-table',
    props: {
      type: {
        type: String
      },
      title: String
    },
    components: {
      Vuetable,
      VuetablePagination
    },
    computed: {
      ...mapState(['currentProfile', 'currentApiURL', 'endPoint', 'parameters', 'serverType', 'profileId'])
    },
    data() {
      return {
        siteId: secureStorage.getItem("defaultSiteId"),
        accessRights: [],
        drawerVisible: false,
        loadedData: '',
        userProductGroupAccess: [],
        filterStatus: "",
        profileAction: "",
        errorMessage: null,
        successMessage: null,
        componentKey: 0,
        visible: false,
        availableFields: [],
        apiURL: "",
fields: ["site", "activity", {name: "terminal_name", title: "terminal name"}, {name: "cashier_name", title: "cashier name"}, { name: "date", callback: (value) => this.formatDate(value) },],        sortOrder: [{
          field: "date",
          direction: "desc"
        }],
        httpOptions: {
          headers: {
            Authorization: 'Bearer ' + secureStorage.getItem("accessToken"), 'Request-Source':"BXI-Web"
          }
        },
        css: {
          table: {
            tableClass: 'table table-sm table-striped table-bordered table-hovered',
            loadingClass: 'loading'
          },
          pagination: {
            infoClass: 'pull-right',
            wrapperClass: 'vuetable-pagination pull-right',
            activeClass: 'btn-primary btn-sm',
            disabledClass: 'disabled',
            pageClass: 'btn btn-border',
            linkClass: 'btn btn-border',
            icons: {
              first: '',
              prev: '',
              next: '',
              last: '',
            },
          }
        }
      }
    },
    watch: {
      currentApiURL: function () {
        this.$refs.vuetable.resetData()
        this.apiURL = this.endPoint + 'system_notifications'
        this.accessRights = this.$attrs.accessRights
      },
      parameters: function () {
        this.apiURL = this.endPoint + 'system_notifications'
        this.apiURL = this.apiURL + this.parameters
        this.$refs.vuetable.selectedTo = []		
        this.checkedItems = []
      }
    },
    methods: {
      closeDrawer(){
        this.onClose()
      },
      refreshPage() {
        this.onClose()
        this.$refs.vuetable.refresh()
        this.successMessage = "Successful Operation"
        this.errorMessage = null
      },
      onClose() {
        this.drawerVisible = false;
        this.visible = false
        this.componentKey++
      },
      formatDate(value){
        let formattedDate = moment(value).format("YYYY-MM-DD HH:mm:ss A")
        return formattedDate;
      },
      removeMessage(type) {
        if (type == 'error')
          this.errorMessage = null
        else
          this.successMessage = null
      },
      async showActionDrawer(action) {
        this.profileAction = action
        this.visible = true
        this.drawerVisible = true;
      },
      async onPaginationData(paginationData) {
        this.$refs.pagination.setPaginationData(paginationData);
        this.loadedData = paginationData.data
        this.setNotificationAsViewed(this.loadedData)
      },
      async onLoadError(error) {
        // request for new token or reauthenticate
        if (error.response.status == 401) {
          var auth_response = await HTTPRequest.authenticate(component_x.endPoint)
          if (auth_response["status"] == "Ok") {
            this.$router.go();
          } else {
            alert("Cannot get access token. Please login again.")
            this.$router.push("/")
          }
        } else {
          if(error.response.data.error == "Session expired"){
              alert("Session is already expired. Please login again.")
              document.getElementById("logoutButton").click()
          }
        }
      },
      onChangePage(page) {
        this.$refs.vuetable.changePage(page);
      },
      async setNotificationAsViewed(loadedData){
        let data = loadedData.map(item => {
          return item.id
        })
        if(data.length){
          let viewedNotificationPayload = {data};
          let post_request = await HTTPRequest.postRequest(this.endPoint + 'system_notifications/updateNotificationAsViewed', null, viewedNotificationPayload)
          if(post_request == undefined){
            // this.$emit('refreshPage', event)
          } else {
            if(post_request["error"] == undefined){
            // this.$emit('refreshPage', event)
            } else {
              this.errors = post_request["error"].split(",")
            }
          }
        }
        
      },
      download() {
        var payload = {};
        var additional_parameters = "";
        var baseUrl = this.endPoint + 'system_notifications' + "/download?file_type=csv";
        if (this.filterStatus == "0") {
          // All
          payload["type"] = "all";
        } else if (this.filterStatus == "1") {
          // Current Page
          var ids = this.$refs.vuetable.tableData.map(({ id }) => id)
          payload["type"] = "current_page";
          if (ids == 0) {
            this.errors.push('No Record(s)');
            return;
          } else {
            payload["ids"] = ids
          }
        } else {
          // Filtered
          payload["type"] = "filtered";
          additional_parameters = this.parameters;
        }

        var exportFields = this.fields;
        payload["fields"] = exportFields;
        payload["site_id"] = this.siteId;
        additional_parameters = additional_parameters.replace("?", "&");

        axios({
          url: baseUrl + additional_parameters,
          method: "POST",
          responseType: "blob", // important
          headers: {
            Authorization: "Bearer " + secureStorage.getItem("accessToken"),
            "Access-Control-Allow-Origin": "*", 'Request-Source':"BXI-File"
          },
          data: payload,
        }).then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", "file.csv");
          document.body.appendChild(link);
          link.click();
          this.onClose();
          this.filterStatus = null;
          this.successMessage = "Download successful";
        });
    },

    },
    mounted: async function () {
      component_x = this;
      var userId = secureStorage.getItem("userId")
      this.accessRights = this.$attrs.accessRights;
      this.apiURL = this.endPoint + 'system_notifications' + '?site_id=' + this.siteId
    }
  }
</script>

<style>
</style>